__turbopack_context__.v({
  "chat": "contextual-support-drawer-module__KC5Lba__chat",
  "composer": "contextual-support-drawer-module__KC5Lba__composer",
  "composerRow": "contextual-support-drawer-module__KC5Lba__composerRow",
  "contextCard": "contextual-support-drawer-module__KC5Lba__contextCard",
  "desktopActions": "contextual-support-drawer-module__KC5Lba__desktopActions",
  "desktopCloseIcon": "contextual-support-drawer-module__KC5Lba__desktopCloseIcon",
  "fileInput": "contextual-support-drawer-module__KC5Lba__fileInput",
  "hours": "contextual-support-drawer-module__KC5Lba__hours",
  "imageButton": "contextual-support-drawer-module__KC5Lba__imageButton",
  "imageDraft": "contextual-support-drawer-module__KC5Lba__imageDraft",
  "messageImage": "contextual-support-drawer-module__KC5Lba__messageImage",
  "mobileBackIcon": "contextual-support-drawer-module__KC5Lba__mobileBackIcon",
  "panel": "contextual-support-drawer-module__KC5Lba__panel",
  "sendIconButton": "contextual-support-drawer-module__KC5Lba__sendIconButton",
});
